import type { CalendarDate } from '@baby-tracker/validation';
import { shiftCalendarDate } from '@baby-tracker/validation';
import type { ReactElement } from 'react';

import { Button } from '../../ui/Button.js';
import fieldStyles from '../../ui/fields.module.css';

export function DayStepper({
    date,
    today,
    onChange,
}: {
    date: CalendarDate;
    today: CalendarDate;
    onChange: (date: CalendarDate) => void;
}): ReactElement {
    const isToday = date === today;
    return (
        <div className={fieldStyles.row} role="group" aria-label="Day">
            <Button
                variant="secondary"
                onClick={() => {
                    onChange(shiftCalendarDate(date, -1));
                }}
            >
                Previous day
            </Button>
            <Button
                variant="secondary"
                disabled={isToday}
                onClick={() => {
                    onChange(shiftCalendarDate(date, 1));
                }}
            >
                Next day
            </Button>
            {isToday ? null : (
                <Button
                    variant="ghost"
                    onClick={() => {
                        onChange(today);
                    }}
                >
                    Today
                </Button>
            )}
        </div>
    );
}
